/*
servers
speech
keyword
calendar
image
trash
*/

const SvgIcon = (props) => {
  switch (props.name) {
    case "servers": {
      return (
        <svg
          width={56}
          height={48}
          viewBox="0 0 56 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect y={0.5} width={55.9853} height={13.8235} rx={3.45588} fill="#6792F7" />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 6.912 8.794)"
            fill="#B7C4E8"
          />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 15.897 8.794)"
            fill="#B7C4E8"
          />
          <rect y={17.0883} width={55.9853} height={13.8235} rx={3.45588} fill="#B7C4E8" />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 6.912 25.382)"
            fill="#6792F7"
          />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 15.897 25.382)"
            fill="#6792F7"
          />
          <rect y={33.6765} width={55.9853} height={13.8235} rx={3.45588} fill="#6792F7" />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 6.912 41.97)"
            fill="#B7C4E8"
          />
          <rect
            width={5.52941}
            height={3.45588}
            rx={1.72794}
            transform="matrix(1 0 0 -1 15.897 41.97)"
            fill="#B7C4E8"
          />
        </svg>
      );
    }
    case "speech":
      return (
        <svg
          width={47}
          height={48}
          viewBox="0 0 47 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_5758_1646)">
            <path
              d="M38.775 15.188v.587a14.205 14.205 0 01-12.878 14.012l-4.524 4.847a3.524 3.524 0 01-6.098-2.409v-2.35h-3.32c-.46 0-.921-.023-1.38-.07v.07c0 6.31 5.164 11.474 11.62 11.75l5.147 5.517a1.174 1.174 0 00.858.358 1.175 1.175 0 001.175-1.175v-4.7h5.67A11.967 11.967 0 0047 29.669v-3.113a11.973 11.973 0 00-8.225-11.369z"
              fill="#6792F7"
            />
            <path
              d="M11.956 27.525A11.967 11.967 0 010 15.569v-3.113A11.967 11.967 0 0111.956.5h12.513a11.967 11.967 0 0111.956 11.956v3.319c0 6.31-5.164 11.474-11.62 11.75l-5.147 5.517a1.174 1.174 0 01-.858.358 1.175 1.175 0 01-1.175-1.175v-4.7h-5.67z"
              fill="#B7C4E8"
            />
          </g>
          <defs>
            <clipPath id="clip0_5758_1646">
              <path fill="var(--text-color)" transform="translate(0 .5)" d="M0 0H47V47H0z" />
            </clipPath>
          </defs>
        </svg>
      );
    case "keyword":
      return (
        <svg
          width={55}
          height={32}
          viewBox="0 0 55 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect y={0.157532} width={54.0822} height={13.5205} rx={2.22767} fill="#B7C4E8" />
          <rect y={17.6781} width={34.7671} height={14.1644} rx={2.22767} fill="#6792F7" />
        </svg>
      );
    case "calendar":
      return (
        <svg
          width={46}
          height={47}
          viewBox="0 0 46 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M39.093 4.214H36.66V0h-4.583v4.214H13.747V0H9.165v4.214H6.874A6.881 6.881 0 000 11.088v29.038A6.881 6.881 0 006.874 47h32.22a6.881 6.881 0 006.873-6.873v-29.04a6.881 6.881 0 00-6.874-6.873zm2.291 35.913c0 1.262-1.027 2.29-1.718 2.29H7.446c-1.836 0-2.864-1.028-2.864-2.29v-22.34h36.802v22.34z"
            fill="#B7C4E8"
          />
          <path d="M10.188 23.786h15.677v12.919H10.19V23.786z" fill="#6792F7" />
        </svg>
      );
    case "image":
      return (
        <svg
          width={52}
          height={42}
          viewBox="0 0 52 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M29.757.766c1.578 0 3.092.636 4.208 1.769a6.086 6.086 0 011.743 4.27H5.951v24.162a5.908 5.908 0 01-4.208-1.77A6.086 6.086 0 010 24.928V6.806c0-1.602.627-3.138 1.743-4.271A5.907 5.907 0 015.951.765h23.806z"
            fill="#B7C4E8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.146 11.14a3.619 3.619 0 00-3.619 3.618v22.857a3.619 3.619 0 003.62 3.62H48.34a3.619 3.619 0 003.62-3.62V14.758a3.62 3.62 0 00-3.62-3.619H14.146zm34.195 26.475H14.147L25.51 18.377l10.039 15.62 6.115-12 6.676 15.618z"
            fill="#6792F7"
          />
        </svg>
      );
    case "trash":
      return (
        <svg
          width={45}
          height={53}
          viewBox="0 0 45 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.808 1.128c.37-.262.795-.401 1.23-.401h4.678c.435 0 .86.139 1.23.4.37.263.668.638.862 1.084l1.694 3.883h7.912c.62 0 1.216.283 1.655.786.438.503.685 1.186.685 1.897 0 .712-.247 1.395-.685 1.898-.44.503-1.034.786-1.655.786v18.723a12.812 12.812 0 00-8.297 13.48H7.02c-1.241 0-2.431-.565-3.309-1.572-.877-1.006-1.37-2.371-1.37-3.795V11.461c-.62 0-1.216-.283-1.655-.786C.246 10.172 0 9.489 0 8.777c0-.711.246-1.394.685-1.897.439-.503 1.034-.786 1.655-.786h7.912l1.694-3.883c.194-.446.492-.821.862-1.083zm17.606 36.894v.275c0 .497-.06.986-.175 1.456a1.603 1.603 0 01.175-1.731zM10.044 14.93c-.44.503-.686 1.185-.686 1.897V32.93c0 .712.247 1.394.685 1.898.44.503 1.034.785 1.655.785.62 0 1.215-.282 1.654-.785.439-.504.685-1.186.685-1.898V16.828c0-.712-.246-1.394-.685-1.897-.439-.504-1.034-.786-1.654-.786-.62 0-1.216.282-1.655.786zm9.358 0c.438-.504 1.034-.786 1.654-.786.62 0 1.216.282 1.654.786.44.503.686 1.185.686 1.897V32.93c0 .712-.247 1.394-.686 1.898-.438.503-1.034.785-1.654.785-.62 0-1.216-.282-1.654-.785-.439-.504-.686-1.186-.686-1.898V16.828c0-.712.247-1.394.686-1.897z"
            fill="#6792F7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.848 52.273a10.065 10.065 0 100-20.13 10.065 10.065 0 000 20.13zm-1.627-13.47a1.258 1.258 0 00-1.779 1.779l1.627 1.627-1.627 1.626a1.257 1.257 0 101.78 1.78l1.626-1.628 1.627 1.627a1.258 1.258 0 001.779-1.779l-1.627-1.627 1.627-1.626a1.258 1.258 0 00-1.78-1.78l-1.626 1.627-1.627-1.626z"
            fill="#B7C4E8"
          />
        </svg>
      );
    default:
      return (
        <svg
          width={75}
          height={75}
          viewBox="0 0 75 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.215 57.143h28.57V15.102a2.602 2.602 0 00-2.601-2.602H25.817a2.602 2.602 0 00-2.602 2.602v42.04zM37.5 25.077a12.5 12.5 0 11-12.5 12.5 12.514 12.514 0 0112.5-12.5zm-5.875-9.203c0-.391.317-.708.708-.708h7.054a.708.708 0 010 1.415h-7.054a.708.708 0 01-.708-.707zm9.765 0c0-.391.316-.708.707-.708h.568a.708.708 0 110 1.415h-.568a.708.708 0 01-.707-.707z"
            fill="#B8C3E9"
          />
          <path
            d="M23.215 59.822a2.68 2.68 0 002.678 2.678h23.214a2.679 2.679 0 002.679-2.678v-.893H23.214v.892z"
            fill="#B8C3E9"
          />
          <path
            d="M39.677 28.228l-.875.219a5.81 5.81 0 01-4.941-1.022c2.337-.826 4.891-.8 7.211.074-.402.348-.88.598-1.395.729zM40.384 40.27a1.623 1.623 0 01-1.309-1.716c.028-.39.194-.758.47-1.036a24.458 24.458 0 016.374-4.594l.886-.446a10.639 10.639 0 01.835 8.078l-.25-.188a5.23 5.23 0 00-5.854-.302 1.623 1.623 0 01-1.152.204z"
            fill="#6C8EF8"
          />
          <path
            d="M31.271 37.662a5.2 5.2 0 012.27 6.138 5.252 5.252 0 01-2.053 2.684 10.683 10.683 0 0015.476-4.205l-.643-.483a3.451 3.451 0 00-3.862-.198 3.417 3.417 0 01-4.173-5.345c2-2 4.309-3.665 6.839-4.928l.696-.349a10.771 10.771 0 00-3.035-2.663 5.223 5.223 0 01-2.68 1.648l-.874.218a7.573 7.573 0 01-7.16-1.945 10.768 10.768 0 00-4.412 4.79l1.544 2.574a6.04 6.04 0 002.067 2.064z"
            fill="#6C8EF8"
          />
          <path
            d="M31.817 40.948c.271.736.283 1.543.03 2.286a3.444 3.444 0 01-1.878 2.035 10.636 10.636 0 01-3.064-10.035l.77 1.28a7.819 7.819 0 002.678 2.678 3.42 3.42 0 011.464 1.756z"
            fill="#6C8EF8"
          />
        </svg>
      );
  }
};

export default SvgIcon;
